import React, { useEffect, useState } from 'react';
import { Share, Smartphone, X } from 'lucide-react';
import { useI18n } from '../../utils/i18n';
import {
  INSTALL_EREIGNIS, androidEreignis, vergissAndroidEreignis, geraetsDaten,
  hinweisArt, laeuftInstalliert, liesPause, setzePause
} from '../../utils/installHinweis';
import './mobil.css';

// Leiste "Als App installieren?" am unteren Rand, nur auf Android und iOS.
// Erscheint mit kurzer Verzögerung, damit sie nicht mit dem Laden der Seite
// konkurriert. "Später" pausiert sie für 14 Tage.
const VERZOEGERUNG_MS = 3000;

const InstallHinweis = ({ verzoegerungMs = VERZOEGERUNG_MS }) => {
  const { t } = useI18n();
  const [art, setArt] = useState(null);
  const [zeitErreicht, setZeitErreicht] = useState(verzoegerungMs <= 0);

  useEffect(() => {
    const pruefe = () => setArt(hinweisArt({
      geraet: geraetsDaten(),
      installiert: laeuftInstalliert(),
      pausiert: liesPause(),
      androidEreignisDa: !!androidEreignis()
    }));
    pruefe();
    window.addEventListener(INSTALL_EREIGNIS, pruefe);
    return () => window.removeEventListener(INSTALL_EREIGNIS, pruefe);
  }, []);

  useEffect(() => {
    if (verzoegerungMs <= 0) return undefined;
    const timer = setTimeout(() => setZeitErreicht(true), verzoegerungMs);
    return () => clearTimeout(timer);
  }, [verzoegerungMs]);

  if (!art || !zeitErreicht) return null;

  const spaeter = () => { setzePause(); setArt(null); };

  const installieren = async () => {
    const ereignis = androidEreignis();
    if (!ereignis) { setArt(null); return; }
    // Ein beforeinstallprompt-Ereignis lässt sich nur einmal benutzen.
    vergissAndroidEreignis();
    setArt(null);
    try {
      await ereignis.prompt();
      const wahl = await ereignis.userChoice;
      if (wahl && wahl.outcome === 'dismissed') setzePause();
    } catch (_) {
      setzePause();
    }
  };

  return (
    <div className="mobil-install" role="dialog" aria-live="polite" aria-label={t('mobile.installTitle', 'Als App installieren?')}>
      <div className="mobil-install-icon" aria-hidden="true"><Smartphone size={24} /></div>
      <div className="mobil-install-text">
        <strong>{t('mobile.installTitle', 'Als App installieren?')}</strong>
        {art === 'ios' ? (
          <span>
            {t('mobile.installIosBefore', 'Tippe auf')}{' '}
            <Share size={16} aria-label={t('mobile.installIosShare', 'Teilen')} className="mobil-install-share" />{' '}
            {t('mobile.installIosAfter', 'und dann auf „Zum Home-Bildschirm“.')}
          </span>
        ) : (
          <span>{t('mobile.installAndroidText', 'Tickets öffnet sich dann wie eine App vom Startbildschirm.')}</span>
        )}
      </div>
      <div className="mobil-install-aktionen">
        {art === 'android' && (
          <button type="button" className="btn btn-primary mobil-touch" onClick={installieren}>
            {t('mobile.installButton', 'Installieren')}
          </button>
        )}
        <button type="button" className="btn btn-secondary mobil-touch" onClick={spaeter}>
          {art === 'ios' ? t('mobile.installGotIt', 'Verstanden') : t('mobile.installLater', 'Später')}
        </button>
      </div>
      <button type="button" className="mobil-install-zu" onClick={spaeter} aria-label={t('common.close', 'Schließen')} title={t('common.close', 'Schließen')}>
        <X size={18} />
      </button>
    </div>
  );
};

export default InstallHinweis;
